// Geomancer pure helpers. No React, no Three.js.
//
// ── Codex (Geomancer) ──
//   "Tap → Play or draw a site. If you played an earth site, fill a
//    void adjacent to you with Rubble.
//    Tap → Replace an adjacent Rubble with the topmost site of your atlas."
//
// "Adjacent" = cardinal-neighbor (4-direction).
// "Void"     = a cell with no Site.
// "Earth site" = a cell whose Sites sum to earth affinity > 0.

const GEOMANCER_ID = 'sorcery-geomancer';
const RUBBLE_ID = 'sorcery-rubble';

/**
 * Find a Rubble card sitting at (col, row), or null.
 */
export function rubbleAtCell(meshes, cellAt, col, row) {
  for (const [, mesh] of meshes) {
    const card = mesh?.userData?.cardInstance;
    if (!card?.isSite || card.cardId !== RUBBLE_ID) continue;
    const cell = cellAt(mesh.position.x, mesh.position.z);
    if (cell && cell.col === col && cell.row === row) return card;
  }
  return null;
}

/**
 * Rubble cells Geomancer's second tap may replace: his own square plus the
 * cardinal-adjacent ones (#34. Standing on the Rubble is the common case
 * and must be offered).
 */
export function adjacentRubbleCells(sourceCell, meshes, cellAt) {
  const out = new Set();
  if (!sourceCell) return out;
  const deltas = [[0, 0], [1, 0], [-1, 0], [0, 1], [0, -1]];
  for (const [dc, dr] of deltas) {
    const nc = sourceCell.col + dc;
    const nr = sourceCell.row + dr;
    if (rubbleAtCell(meshes, cellAt, nc, nr)) out.add(`${nc},${nr}`);
  }
  return out;
}

/**
 * Cardinal-adjacent void cells (no Site present). Used by Geomancer's
 * earth-site bonus to gate the Rubble spawn cell pick.
 */
export function adjacentVoidCells(sourceCell, sitedCells, totalCols, totalRows) {
  const out = new Set();
  if (!sourceCell) return out;
  const deltas = [[1, 0], [-1, 0], [0, 1], [0, -1]];
  for (const [dc, dr] of deltas) {
    const nc = sourceCell.col + dc;
    const nr = sourceCell.row + dr;
    if (nc < 0 || nr < 0 || nc >= totalCols || nr >= totalRows) continue;
    const key = `${nc},${nr}`;
    if (sitedCells.has(key)) continue;
    out.add(key);
  }
  return out;
}

/**
 * Find the Geomancer avatar a given controller owns, or null. Matches
 * by cardId so name renames in the catalog don't drift the rule.
 */
export function findControllerGeomancer(meshes, controllerRotated) {
  for (const [, mesh] of meshes) {
    const card = mesh?.userData?.cardInstance;
    if (!card || card.cardId !== GEOMANCER_ID) continue;
    if (!!card.rotated !== !!controllerRotated) continue;
    return card;
  }
  return null;
}
